module.exports = __webpack_public_path__ + "img/icon_sheet_of_paper.2965b042.svg";